import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificationStore = defineStore("notification", () => {
    const mechanicDeleted = ref(0);

    const notifyMechanicDeleted = () => {
        mechanicDeleted.value++;
    };

    return {
        mechanicDeleted,
        notifyMechanicDeleted,
    };
});
